import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { TOUR_STORIES } from '../../../constants/define/translation';

export const TourStoryPageHeader = () => {
  const { t } = useTranslation(TOUR_STORIES);

  const extra: ExtraHeaderPage[] = [];

  return <ContentPageHeader title={t('header.title')} extra={extra} sortingEnabled />;
};
